import React, { Component } from "react";
import ReactDOM from 'react-dom';

function removeEmptyFilters(filter) {
    return (filter) ? true : false;
}

function parseFilterSettingsForFetch(filters) {
    const parsedFilters = [];

    filters.forEach((filter) => {
        if (filter) {
            parsedFilters.push({ 'Key': filter.value, 'Description': "" });
        }
    });

    return parsedFilters;
}

function getArticles(scope) {
    const ContentRefId = window.ArticleHubContentRefId || '';
    const url = window.ArticleHubArticleEndpointUrl; 
    const fetchSettings = {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            "Filters": parseFilterSettingsForFetch(scope.state.selectedFilters),
            ContentRefId
        })
    };

    if (ContentRefId !== '') {
        fetch(url, fetchSettings)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}, request failed`);
                }
                return response.json();
            })
            .then((cards) => {
                scope.setState({ 'cards': cards.Articles.slice() });
            });
    }
}

class Card extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const article = this.props.article;
        const hasImage = article.CardImageUrl !== null;

        return (
            <a href={article.CardUrl} className="paper-journal__card">
                <div className="paper-journal__card-header">
                    {/*<strong>Category name</strong>*/}
                    <h4>{article.CardTitle}</h4>
                </div>
                {hasImage && (
                    <img src={article.CardImageUrl} />
                )}
                {/* Temporary test image */}
                {/*<img src="https://i.ytimg.com/vi/jNQXAC9IVRw/0.jpg" />*/}
            </a>
        );
    }
}

class PaperJournalView extends Component {
    constructor(props) {
        const filters = window.ArticleHubFilterControls || [];
        const preSelectedFilters = new Array(filters.length);

        filters.forEach((filterCategory, i) => {
            filterCategory.items.forEach((filter, j) => {
                if (filter.isSelected) {
                    preSelectedFilters[i] = {
                        text: filter.text,
                        value: filter.value,
                    };
                }
            })
        });

        super(props);
        this.state = {
            filterControls: filters,
            selectedFilters: preSelectedFilters,
            cards: [],
        };
        this.filterOptionHandler = this.filterOptionHandler.bind(this);
    }

    componentDidMount() {
        getArticles(this);
    }

    filterOptionHandler(filterControlIndex, event) {
        const controlState = this.state.selectedFilters.slice();
        const value = event.target.value;

        if (value !== '') {
            controlState[filterControlIndex] = {
                value,
                text: event.nativeEvent.target[
                    event.nativeEvent.target.selectedIndex
                ].text,
            };
        } else {
            controlState[filterControlIndex] = null;
        }

        this.setState({
            'selectedFilters': controlState,
        }, () => {
            getArticles(this);
        });
    }

    render() {
        return (
            <div className="paper-journal__view">
                <div className="paper-journal__filters">
                    {this.state.filterControls.map((control, i) => (
                        <div className="styled-dropdown paper-journal__filter" key={`filter-control-${i}`}>
                            <div className="styled-dropdown__display">
                                {(this.state.selectedFilters[i])
                                    ? this.state.selectedFilters[i].text
                                    : control.title}
                            </div>
                            <select onChange={this.filterOptionHandler.bind(this, i)}>
                                <option value="">---</option>
                                {control.items.map((item) => (
                                    <option key={item.value}
                                        value={item.value}>
                                        {item.text}
                                    </option>
                                ))}
                            </select>
                        </div>
                    ))}

                </div>
                <div className="paper-journal__cards">
                    {this.state.cards.map((card) => (
                        <Card key={card.CardLink} article={card} />
                    ))}
                </div>
            </div>
        );
    }
}

class PaperJournal {
    constructor(element) {
        this.element = element;
        this.view = element.querySelector(".paper-journal__root");
        this.init();
    }

    init() {
        ReactDOM.render(
            <PaperJournalView />,
            this.view
        );
    };
}

export default PaperJournal;